/** Asset 360 / Site 360 (tracker 39), under assets:report360. See locales/en-US/report360.ts. */
export const report360 = {
  ui: {
    finding: "Befund",
    versionPrepared: "Version {{version}} · erstellt am {{date}}",
    kindAsset: "Asset 360",
    kindSite: "Site 360",
    kindVersion: "{{kind}} · Version {{version}}",
    preparedFor: "Erstellt für {{name}}",
    writtenFor: "Geschrieben für: {{reader}}",
    prepared: "Erstellt am {{date}}",
    figuresAsOf: "Zahlen vom {{date}}",
    wordsByAi: "Erläuterungen von KI (Google Gemini) auf Basis der Zahlen der App. Die KI ändert nie eine Zahl.",
    wordsByApp: "Von der App aus Ihren Daten erstellt.",
    verdictTitle: "Gesamturteil",
    contents: "Inhalt",
    contentsLine: "{{number}}. {{title}}",
    contentsTail: "Danach: Maßnahmenplan, Datenqualität, über diesen Bericht.",
    summaryTitle: "Zusammenfassung",
    keyFindings: "Wichtigste Ergebnisse",
    doFirst: "Was zuerst zu tun ist",
    bullet: "• {{text}}",
    scorecardTitle: "Kennzahlen",
    noData: "Noch keine Daten",
    change30d: "{{value}} in 30 Tagen",
    sectionTitle: "{{number}}. {{title}}",
    whatItMeans: "Was das bedeutet",
    actionsTitle: "Maßnahmenplan",
    actionsNone: "Im Moment ist nichts zu tun.",
    priority1: "Sofort",
    priority2: "Als Nächstes",
    priority3: "Bei Gelegenheit",
    due_one: "Innerhalb von {{count}} Tag",
    due_other: "Innerhalb von {{count}} Tagen",
    raiseJob: "Auftrag anlegen",
    raiseInspection: "Inspektion starten",
    open: "Öffnen",
    dataQualityTitle: "Datenqualität",
    dataQualityIntro: "Wie weit sich dieser Bericht auf Ihre Daten stützen kann. Lücken senken die Sicherheit jedes Abschnitts.",
    cannotJudge: "Was der Bericht nicht beurteilen konnte",
    getMoreTitle: "Mehr aus diesem Bericht holen",
    getMoreIntro: "Nur Sie sehen das. Es ist nie in dem enthalten, was Sie teilen.",
    aboutTitle: "Über diesen Bericht",
    coverage: "{{recorded}} von {{total}} Arten von Daten sind vorhanden.",
    coverageMissing: "Noch nicht erfasst: {{list}}.",
    aboutAsset_one: "Die Werte stammen aus den nächtlichen Zahlen; Aufträge und Inspektionen umfassen den letzten {{count}} Tag.",
    aboutAsset_other: "Die Werte stammen aus den nächtlichen Zahlen; Aufträge und Inspektionen umfassen die letzten {{count}} Tage.",
    aboutSite_one: "Die Werte stammen aus der nächtlichen Zusammenfassung des Standorts; Aufträge umfassen den letzten {{count}} Tag.",
    aboutSite_other: "Die Werte stammen aus der nächtlichen Zusammenfassung des Standorts; Aufträge umfassen die letzten {{count}} Tage.",
    aboutAi: "Die KI hat die Zusammenfassung und die Erläuterungen für den gewählten Leser geschrieben. Jede Zahl, Bewertung und jedes Ergebnis stammt von der App.",
    highRisk: "hohes Risiko",
    nothingToShow: "Noch nichts anzuzeigen.",
    labelValue: "{{label}}: {{value}}",
    whereItSits: "Wo es sich befindet",
    dependsOn: "Hängt ab von",
    serves: "Versorgt",
    none: "Nichts erfasst",
    singlePoints: "Einzelne Fehlerquelle: {{names}}",
    hiddenLinks_one: "{{count}} weitere Verknüpfung, die Sie nicht öffnen können",
    hiddenLinks_other: "{{count}} weitere Verknüpfungen, die Sie nicht öffnen können",
    prepareTitle: "Bericht vorbereiten",
    readerLabel: "Für wen ist er?",
    readerA11y: "Bericht schreiben für: {{reader}}",
    hideNames: "Namen der Dienstleister ausblenden",
    hideNamesHint: "Zeigt Dienstleister als Dienstleister A, B usw.",
    preparedForLabel: "Erstellt für (optional)",
    preparedForPlaceholder: "Zum Beispiel Hafen Immobilien GmbH",
    storyTitle: "KI-Fassung",
    storyHint: "Google Gemini schreibt die Zusammenfassung und jede Erläuterung für Ihren Leser neu, in der gewählten Sprache. Zahlen ändert es nie.",
    languageLabel: "Sprache",
    focusLabel: "Schwerpunkt der KI",
    pickFocus: "Wählen Sie mindestens einen Abschnitt als Schwerpunkt für die KI.",
    weakData: "Die Datenqualität ist schwach ({{score}} von 100). Die KI sagt, was sie nicht beurteilen kann, statt zu raten.",
    generate: "KI-Fassung schreiben",
    chargedWhenWritten: "Das Guthaben wird erst abgebucht, wenn der Bericht geschrieben ist. Schlägt er fehl, wird nichts berechnet.",
    queuedTitle: "Ihre KI-Fassung ist in der Warteschlange",
    queuedBody: "Platz {{position}} in der Warteschlange. Sie können diese Seite verlassen: Sie erhalten eine Benachrichtigung, sobald sie fertig ist.",
    runningTitle: "Ihre KI-Fassung wird geschrieben…",
    runningBody: "Das dauert meist weniger als eine Minute. Sie können diese Seite verlassen: Sie erhalten eine Benachrichtigung, sobald sie fertig ist.",
    failedTitle: "Die KI-Fassung konnte nicht geschrieben werden",
    failedBody: "Es wurde nichts berechnet. Versuchen Sie es gleich noch einmal.",
    joined: "Jemand hat diesen Bericht bereits angefordert, daher erhalten Sie beide denselben.",
    showingAi: "KI-Fassung {{version}}, geschrieben am {{date}}",
    showingApp: "Fassung der App für diesen Leser",
    showApp: "Fassung der App zeigen",
    showAi: "KI-Fassung zeigen",
    loading: "Bericht wird erstellt…",
    loadFailed: "Der Bericht konnte nicht geöffnet werden.",
    busy: "Berichte sind gerade ausgelastet. Versuchen Sie es gleich noch einmal.",
    retry: "Erneut versuchen",
    requestFailedTitle: "KI-Fassung konnte nicht angefordert werden",
    earlierTitle: "Vor Asset 360",
    earlierHint: "KI-Berichte aus der Zeit vor Asset 360 und Site 360. Tippen Sie auf ein Datum, um ihn zu lesen.",
    shareTitle: "{{kind}}: {{name}}",
  },
  reader: {
    asset_manager: "Asset-Manager",
    client: "Kunde",
    landlord: "Vermieter",
    site_manager: "Standortleiter",
    investor: "Investor",
  },
  readerHint: {
    asset_manager: "Das ganze Bild, vom Umfeld bis zu den Aufträgen, mit allen Abschnitten.",
    client: "Aufträge und Dienstleister zuerst: was erledigt wurde, wie gut und wie pünktlich.",
    landlord: "Compliance und Risiko zuerst. Namen der Dienstleister sind ausgeblendet, sofern Sie sie nicht einblenden.",
    site_manager: "Aufträge und Zustand zuerst, mit dem Maßnahmenplan direkt nach der Zusammenfassung.",
    investor: "Etwa zwei Seiten: Gesamturteil, Kennzahlen, Risiko, Compliance und die wichtigsten Maßnahmen.",
  },
  rating: {
    on_track: "Im Plan",
    watch: "Beobachten",
    needs_attention: "Handlungsbedarf",
  },
  confidence: {
    high: "Sicherheit: hoch",
    medium: "Sicherheit: mittel",
    low: "Sicherheit: niedrig",
  },
  dqBand: {
    strong: "Stark",
    fair: "Mittel",
    weak: "Schwach",
  },
  dimension: {
    complete: "Vollständig",
    current: "Aktuell",
    evidenced: "Belegt",
    connected: "Verknüpft",
    consistent: "Stimmig",
  },
  scorecard: {
    asset: {
      compliance: "Compliance",
      risk: "Risiko",
      condition: "Zustand",
      inspections_on_time: "Inspektionen pünktlich",
      right_first_time: "Beim ersten Mal richtig",
      overdue_work: "Überfällige Aufträge",
    },
    site: {
      compliance: "Compliance",
      risk: "Durchschnittliches Risiko",
      condition: "Zustand",
      inspections_on_time: "In diesem Jahr inspizierte Assets",
      right_first_time: "Beim ersten Mal richtig",
      overdue_work: "Überfällige Aufträge",
    },
  },
  section: {
    environment: "Wo es sich befindet und was es umgibt",
    compliance: "Compliance",
    risk: "Risiko",
    condition: "Zustand und Inspektionen",
    work: "Aufträge",
    contractors: "Dienstleister",
    property: "Die Liegenschaft",
    areas: "Gebäude und Bereiche",
    inspections: "Inspektionen",
    siteRisk: "Risiko am ganzen Standort",
  },
  finding: {
    environment: {
      noSite: "Es ist keinem Standort zugeordnet, daher ist sein Umfeld unbekannt.",
      site: "Es befindet sich am Standort {{site}}, wo {{atRisk}} von {{assets}} Assets gefährdet und {{overdue}} Aufträge überfällig sind.",
      siteNoSummary: "Es befindet sich am Standort {{site}}, für den es noch keine nächtliche Zusammenfassung gibt.",
    },
    compliance: {
      expired_one: "Ein Zertifikat oder Dokument ist abgelaufen.",
      expired_other: "{{count}} Zertifikate oder Dokumente sind abgelaufen.",
      expiring_one: "Ein Zertifikat läuft in den nächsten 60 Tagen ab.",
      expiring_other: "{{count}} Zertifikate laufen in den nächsten 60 Tagen ab.",
      noDocuments: "Die Compliance liegt bei {{score}}, aber es sind keine Zertifikate hinterlegt, die das belegen.",
      noFigures: "Es sind noch keine Compliance-Zahlen gespeichert.",
      ok_one: "Die Compliance liegt bei {{score}}, mit {{count}} hinterlegten Dokument und nichts abgelaufen.",
      ok_other: "Die Compliance liegt bei {{score}}, mit {{count}} hinterlegten Dokumenten und nichts abgelaufen.",
      site: "Die Compliance am ganzen Standort liegt bei {{score}}.",
      siteExpired_one: "Am Standort ist ein Dokument abgelaufen.",
      siteExpired_other: "Am Standort sind {{count}} Dokumente abgelaufen.",
    },
    condition: {
      health: "Der Zustand liegt bei {{score}} ({{band}}). Tage seit der letzten Inspektion: {{days}}.",
      inspected: "Es ist noch kein Zustandswert gespeichert. Tage seit der letzten Inspektion: {{days}}.",
      neverInspected: "Es wurde nie inspiziert, daher ist sein aktueller Zustand unbekannt.",
      overdueChecks_one: "Eine geplante Prüfung ist überfällig.",
      overdueChecks_other: "{{count}} geplante Prüfungen sind überfällig.",
    },
    contractors: {
      none: "In diesem Zeitraum hat hier kein Dienstleister gearbeitet.",
      summary_one: "Ein Dienstleister hat {{jobs}} Aufträge erledigt: {{busiest}}.",
      summary_other: "{{count}} Dienstleister haben {{jobs}} Aufträge erledigt. Am meisten hat {{busiest}} übernommen.",
    },
    inspections: {
      noSummary: "Für diesen Standort ist noch keine Inspektionszusammenfassung gespeichert.",
      site: "{{inspected}} von {{assets}} Assets wurden in diesem Jahr inspiziert. {{failed}} von {{inspections}} Inspektionen der letzten 90 Tage fanden Mängel.",
    },
    property: {
      noSummary: "Der Standort umfasst {{assets}} Assets. Es ist noch keine nächtliche Zusammenfassung gespeichert.",
      summary: "Der Standort umfasst {{assets}} Assets. {{atRisk}} sind gefährdet und {{open}} Aufträge sind offen.",
    },
    risk: {
      level: "Das Risiko ist {{level}} ({{score}} von 25).",
      neighbours_one: "Das Risiko ist {{level}} ({{score}} von 25), und ein verknüpftes Asset hat ein hohes Risiko.",
      neighbours_other: "Das Risiko ist {{level}} ({{score}} von 25), und {{count}} verknüpfte Assets haben ein hohes Risiko.",
      notAssessed: "Es wurde keine Risikobewertung durchgeführt.",
      singlePoint: "Das Risiko ist {{level}} ({{score}} von 25), und {{name}} ist eine einzelne Fehlerquelle.",
      site: "Das durchschnittliche Risiko ist {{level}} ({{score}} von 25). {{atRisk}} Assets sind gefährdet.",
      siteNotAssessed: "Die Assets des Standorts wurden nicht risikobewertet.",
    },
    work: {
      none: "In den letzten 12 Monaten wurden keine Aufträge angelegt.",
      ok: "In den letzten 12 Monaten wurden {{done}} Aufträge erledigt, keiner überfällig und keiner zurückgewiesen.",
      overdue_one: "Ein Auftrag ist überfällig. In den letzten 12 Monaten wurden {{done}} Aufträge erledigt.",
      overdue_other: "{{count}} Aufträge sind überfällig. In den letzten 12 Monaten wurden {{done}} Aufträge erledigt.",
      rework_one: "Einer von {{done}} abgeschlossenen Aufträgen wurde zurückgewiesen ({{pct}} % beim ersten Mal richtig).",
      rework_other: "{{count}} von {{done}} abgeschlossenen Aufträgen wurden zurückgewiesen ({{pct}} % beim ersten Mal richtig).",
      siteNone: "In den letzten 90 Tagen wurden für die Assets des Standorts keine Aufträge angelegt.",
      siteOk: "In den letzten 90 Tagen wurden {{done}} Aufträge erledigt und keiner zurückgewiesen.",
      siteRework_one: "Einer von {{done}} abgeschlossenen Aufträgen wurde in den letzten 90 Tagen zurückgewiesen ({{pct}} % beim ersten Mal richtig).",
      siteRework_other: "{{count}} von {{done}} abgeschlossenen Aufträgen wurden in den letzten 90 Tagen zurückgewiesen ({{pct}} % beim ersten Mal richtig).",
    },
    areas: {
      none: "Im Standort sind keine Gebäude oder Bereiche erfasst. Standorte darin: {{n}}.",
      summary_one: "Ein Gebäude oder Bereich ist erfasst; {{top}} enthält {{assets}} Assets.",
      summary_other: "{{count}} Gebäude und Bereiche sind erfasst. Der größte, {{top}}, enthält {{assets}} Assets.",
    },
  },
  meaning: {
    environment: {
      noSite: "Ohne Standort kann der Bericht nicht sagen, was es umgibt oder was ein Problem in der Nähe dafür bedeuten würde.",
      ok: "Das Umfeld ist in gutem Zustand, daher wird ein Problem hier kaum durch die Umgebung verschärft.",
      siteWeak: "Am Standort gibt es offene Probleme. Arbeiten in der Nähe können es stören, und seine eigenen Mängel wiegen schwerer.",
      neighboursRisk_one: "Ein verknüpftes Asset hat ein hohes Risiko, daher könnte ein Ausfall dort auch dieses Asset treffen.",
      neighboursRisk_other: "{{count}} verknüpfte Assets haben ein hohes Risiko, daher könnte ein Ausfall dort auch dieses Asset treffen.",
    },
    compliance: {
      on_track: "Die Unterlagen sind in Ordnung. Rechtzeitig verlängern, dann bleibt es so.",
      watch: "Die Compliance lässt nach. Verlängern Sie, was fällig ist, bevor es beanstandet wird.",
      needs_attention: "Die Compliance braucht jetzt Aufmerksamkeit: Ein Prüfer oder Versicherer würde das bemängeln.",
      none: "Es gibt noch keine Compliance-Zahlen für eine Beurteilung.",
      expired: "Ein abgelaufenes Zertifikat bedeutet, dass der Betrieb bis zur Verlängerung womöglich nicht zulässig oder versichert ist.",
      noDocuments: "Ohne hinterlegte Unterlagen lässt sich der Wert niemandem gegenüber belegen.",
      awaitingCheck_one: "Ein Dokument wartet auf Prüfung und zählt daher noch nicht.",
      awaitingCheck_other: "{{count}} Dokumente warten auf Prüfung und zählen daher noch nicht.",
    },
    risk: {
      on_track: "Das Risiko ist niedrig. Normale Pflege und geplante Prüfungen genügen.",
      watch: "Das Risiko ist mittel. Halten Sie Prüfungen pünktlich ein und achten Sie auf Veränderungen.",
      needs_attention: "Das Risiko ist hoch. Ein Ausfall wäre teuer oder unsicher, handeln Sie nach dem Plan unten.",
      notAssessed: "Ohne Risikobewertung kann niemand sagen, wie schwer ein Ausfall wiegen würde.",
      noLinks: "Das Risiko ist {{level}}. Es sind keine Verknüpfungen zu anderen Assets erfasst, daher sind Folgewirkungen unbekannt.",
      singlePoint: "Andere Assets hängen ohne Ersatz davon ab, daher legt ein Ausfall hier auch sie lahm.",
    },
    condition: {
      on_track: "Es ist in gutem Zustand und wird pünktlich inspiziert.",
      watch: "Der Zustand beginnt nachzulassen. Behalten Sie die nächste Inspektion im Blick.",
      needs_attention: "Der Zustand ist schlecht. Planen Sie Reparatur oder Ersatz.",
      none: "Es gibt noch keinen gespeicherten Zustandswert für eine Beurteilung.",
      neverInspected: "Niemand hat es in der App angesehen, daher ist sein Zustand bis zur Inspektion eine Vermutung.",
      issues_one: "Eine aktuelle Inspektion hat Mängel gefunden, die nachverfolgt werden müssen.",
      issues_other: "{{count}} aktuelle Inspektionen haben Mängel gefunden, die nachverfolgt werden müssen.",
      repeat: "„{{item}}“ tritt immer wieder auf. Die Ursache zu beheben spart wiederholte Einsätze.",
    },
    work: {
      none: "Keine Aufträge heißt entweder, dass nichts nötig war, oder dass Arbeiten nicht in der App erfasst werden.",
      ok: "Aufträge werden pünktlich und beim ersten Mal richtig erledigt.",
      overdue: "Überfällige Aufträge lassen bekannte Probleme ungelöst und erhöhen das Risiko.",
      rework: "Zurückgewiesene Aufträge kosten einen zweiten Einsatz und verzögern die Behebung.",
    },
    contractors: {
      none: "Es sind keine Arbeiten von Dienstleistern erfasst, daher lässt sich ihre Leistung nicht beurteilen.",
      good: "Die Dienstleister arbeiten pünktlich und beim ersten Mal richtig.",
      late_one: "Ein Dienstleister wird oft zu spät fertig.",
      late_other: "{{count}} Dienstleister werden oft zu spät fertig.",
      sentBack_one: "Bei einem Dienstleister wurden Arbeiten zurückgewiesen.",
      sentBack_other: "Bei {{count}} Dienstleistern wurden Arbeiten zurückgewiesen.",
      offApp_one: "Ein Dienstleister nutzt die App nicht, daher sind seine Arbeiten schlechter belegt.",
      offApp_other: "{{count}} Dienstleister nutzen die App nicht, daher sind ihre Arbeiten schlechter belegt.",
    },
    property: {
      on_track: "Die Liegenschaft ist insgesamt in gutem Zustand.",
      watch: "Die Liegenschaft ist größtenteils in Ordnung, einige Bereiche sollten beobachtet werden.",
      needs_attention: "Die Liegenschaft braucht Aufmerksamkeit: Compliance oder Zustand liegen unter dem Soll.",
      truncated: "Dieser Standort umfasst {{n}} Assets; der Bericht liest die ersten 5.000.",
    },
    areas: {
      none: "Ohne Gebäude oder Bereiche kann der Bericht nicht zeigen, wo sich Probleme häufen.",
      ok: "Kein Gebäude und kein Bereich fällt als Problem auf.",
      highRisk: "Assets mit hohem Risiko häufen sich in {{area}}. Beginnen Sie dort.",
    },
    inspections: {
      on_track: "Fast jedes Asset wurde in diesem Jahr inspiziert.",
      watch: "Einige Assets wurden in diesem Jahr nicht inspiziert.",
      needs_attention: "Viele Assets wurden in diesem Jahr nicht inspiziert, daher ist ihr Zustand unbekannt.",
      none: "Es gibt noch keine Inspektionszusammenfassung für eine Beurteilung.",
      overdue: "Geplante Prüfungen sind überfällig. Holen Sie sie nach, bevor Probleme übersehen werden.",
    },
  },
  basis: {
    environment: {
      summary: "Aus der nächtlichen Zusammenfassung des Standorts vom {{date}}.",
      noSummary: "Aus dem Standort-Datensatz; für den Standort gibt es noch keine nächtliche Zusammenfassung.",
    },
    site: {
      summary: "Aus der nächtlichen Zusammenfassung vom {{date}}.",
    },
    compliance: "Aus den nächtlichen Zahlen und den hinterlegten Dokumenten ({{n}}).",
    risk: "Aus der letzten Risikobewertung und den Verknüpfungen zu anderen Assets ({{links}}).",
    condition: "Aus den nächtlichen Zustandswerten und aktuellen Inspektionen ({{n}}).",
    work: {
      year: "Aus den Aufträgen der letzten 12 Monate ({{n}}).",
      ninetyDays: "Aus den Aufträgen der letzten 90 Tage ({{n}}).",
    },
    contractors: {
      year: "Aus den Dienstleister-Aufträgen der letzten 12 Monate ({{n}}).",
      ninetyDays: "Aus den Dienstleister-Aufträgen der letzten 90 Tage ({{n}}).",
    },
    areas: "Aus den am Standort erfassten Orten und den Assets darin ({{n}}).",
    siteRisk: "Aus den Risikobewertungen der Assets des Standorts ({{n}}).",
  },
  score: {
    compliance: {
      on_track: "Unauffällig: Unterlagen in Ordnung.",
      watch: "Einige Unterlagen fällig oder fehlend.",
      needs_attention: "Unterlagen abgelaufen oder fehlend.",
      none: "Noch keine Zahlen.",
    },
    risk: {
      on_track: "Niedriges Risiko.",
      watch: "Mittleres Risiko.",
      needs_attention: "Hohes Risiko.",
      none: "Nicht bewertet.",
    },
    condition: {
      on_track: "Guter Zustand.",
      watch: "Zustand lässt nach.",
      needs_attention: "Schlechter Zustand.",
      none: "Noch keine Zustandswerte.",
    },
    inspectionsOnTime: {
      on_track: "Geplante Prüfungen pünktlich erledigt.",
      watch: "Einige Prüfungen verspätet.",
      needs_attention: "Viele Prüfungen verspätet.",
      none: "Keine geplanten Prüfungen.",
    },
    inspectedThisYear: {
      on_track: "Fast jedes Asset in diesem Jahr inspiziert.",
      watch: "Einige Assets in diesem Jahr nicht inspiziert.",
      needs_attention: "Viele Assets in diesem Jahr nicht inspiziert.",
      none: "Noch keine Inspektionszusammenfassung.",
    },
    rightFirstTime: {
      on_track: "Arbeiten beim ersten Mal richtig.",
      watch: "Einige Arbeiten zurückgewiesen.",
      needs_attention: "Viele Arbeiten zurückgewiesen.",
      none: "Keine abgeschlossenen Arbeiten zum Beurteilen.",
    },
    overdueWork: {
      on_track: "Nichts überfällig.",
      watch: "Aufträge nach Fälligkeit: {{n}}.",
      needs_attention: "Aufträge nach Fälligkeit: {{n}}.",
      none: "Keine Aufträge erfasst.",
    },
  },
  band: {
    posture: {
      on_track: "Unauffällig",
      watch: "Beobachten",
      needs_attention: "Handeln",
    },
    risk: {
      low: "niedrig",
      medium: "mittel",
      high: "hoch",
      extreme: "extrem",
    },
  },
  verdict: {
    on_track: "Im Plan: {{reason}}",
    watch: "Beobachten: {{reason}}",
    needs_attention: "Handlungsbedarf: {{reason}}",
    on_track_all: "Im Plan: Alle Kennzahlen sind in gutem Zustand.",
  },
  reason: {
    compliance: "Die Compliance liegt bei {{value}}.",
    risk: "Das Risiko liegt bei {{value}} von 25.",
    condition: "Der Zustand liegt bei {{value}}.",
    inspections_on_time: "{{value}} % der Inspektionen sind pünktlich.",
    right_first_time: "{{value}} % der Arbeiten sind beim ersten Mal richtig.",
    overdue_work: "Aufträge nach Fälligkeit: {{value}}.",
  },
  stat: {
    jobsWithSubJobs: "Aufträge mit Teilaufträgen",
    familiesOnTime: "Davon pünktlich",
    waitBetweenSteps: "Wartezeit zwischen Schritten",
    stepsSentBack: "Zurückgeschickte Schritte",
    hoursValue: "{{n}} Std.",
    assets: "Assets",
    assetsAtRisk: "Gefährdete Assets",
    checksDone: "Erledigte Prüfungen",
    checksNext60: "Prüfungen in 60 Tagen fällig",
    checksOverdue: "Überfällige Prüfungen",
    checksPlanned: "Geplante Prüfungen",
    expiredDocuments: "Abgelaufene Dokumente",
    failed90d: "Inspektionen mit Mängeln (90 Tage)",
    inspectedThisYear: "In diesem Jahr inspiziert",
    inspections90d: "Inspektionen (90 Tage)",
    jobsDone: "Erledigte Aufträge",
    links: "Verknüpfte Assets",
    neighbours: "Assets in der Nähe",
    onTime: "Pünktlich",
    openJobs: "Offene Aufträge",
    overdueJobs: "Überfällige Aufträge",
    rejected: "Abgelehnt",
    rescheduled: "Verschoben",
    rightFirstTime: "Beim ersten Mal richtig",
    sentBack: "Zurückgewiesen",
    siteAtRisk: "Gefährdete Assets am Standort",
    siteCompliance: "Compliance des Standorts",
    siteHealth: "Zustand des Standorts",
    siteOverdueJobs: "Überfällige Aufträge am Standort",
  },
  col: {
    area: "Bereich",
    asset: "Asset",
    assets: "Assets",
    avgDays: "Durchschnittliche Tage",
    contractor: "Dienstleister",
    date: "Datum",
    document: "Dokument",
    expires: "Läuft ab",
    highRisk: "Hohes Risiko",
    issues: "Mängel",
    job: "Auftrag",
    jobs: "Aufträge",
    kind: "Art",
    level: "Stufe",
    onTime: "Pünktlich",
    reason: "Grund",
    result: "Ergebnis",
    risk: "Risiko",
    sentBack: "Zurückgewiesen",
    site: "Standort",
    status: "Status",
    usesApp: "Nutzt die App",
  },
  visual: {
    areas: "Gebäude und Bereiche",
    byZone: "Assets nach Zone",
    childSites: "Standorte innerhalb dieses Standorts",
    complianceTrend: "Compliance, letzte 90 Tage",
    contractors: "Dienstleister",
    documents: "Dokumente",
    healthTrend: "Zustand, letzte 90 Tage",
    openJobsTrend: "Offene Aufträge, letzte 90 Tage",
    recentInspections: "Aktuelle Inspektionen",
    repeatItems: "Wiederkehrende Mängel",
    rework: "Warum Arbeiten zurückgewiesen wurden",
    riskTrend: "Risiko, letzte 90 Tage",
    topRisk: "Assets mit dem höchsten Risiko",
  },
  docStatus: {
    awaitingCheck: "Wartet auf Prüfung",
    expired: "Abgelaufen",
    expiring: "Läuft bald ab",
    valid: "Gültig",
  },
  result: {
    issues: "Mängel gefunden",
    passed: "Bestanden",
    open: "Nicht abgeschlossen",
  },
  common: {
    yes: "Ja",
    no: "Nein",
    noReason: "Kein Grund angegeben",
    noExpiry: "Kein Ablaufdatum",
  },
  contractors: {
    anonymous: "Dienstleister {{letter}}",
  },
  action: {
    planReplacement: "Den Ersatz von {{name}} planen",
    backup: "Ersatz für {{name}} planen",
    clearOverdue_one: "Den überfälligen Auftrag erledigen",
    clearOverdue_other: "Die {{count}} überfälligen Aufträge erledigen",
    fillDetails: "Fehlende Angaben ergänzen",
    fillSiteDetails: "Fehlende Angaben zum Standort ergänzen",
    inspect: "{{name}} inspizieren",
    inspectRest_one: "Das eine in diesem Jahr nicht inspizierte Asset inspizieren",
    inspectRest_other: "Die {{count}} in diesem Jahr nicht inspizierten Assets inspizieren",
    overdueChecks_one: "Die überfällige Prüfung durchführen",
    overdueChecks_other: "Die {{count}} überfälligen Prüfungen durchführen",
    renewExpired_one: "Das abgelaufene Zertifikat erneuern",
    renewExpired_other: "Die {{count}} abgelaufenen Zertifikate erneuern",
    renewExpiring_one: "Das bald ablaufende Zertifikat erneuern",
    renewExpiring_other: "Die {{count}} bald ablaufenden Zertifikate erneuern",
    repeatFault: "Ursache von „{{item}}“ finden",
    reviewRisk: "Risiko von {{name}} überprüfen",
    rework: "Mit den Dienstleistern über zurückgewiesene Arbeiten sprechen",
  },
  why: {
    pastLife: "Die erwartete Lebensdauer ist überschritten.",
    spendHigh: "Ein Jahr Reparaturen hat die Hälfte oder mehr eines neuen gekostet.",
    backup: "Andere Assets hängen ohne Ersatz davon ab.",
    clearOverdue: "Überfällige Aufträge lassen bekannte Probleme ungelöst.",
    fillDetails: "Die Datenqualität liegt bei {{score}} von 100, was die Aussagekraft des Berichts begrenzt.",
    neverInspected: "Der Zustand ist unbekannt, bis jemand es ansieht.",
    overdueChecks: "Geplante Prüfungen sind überfällig.",
    renewExpired: "Ein abgelaufenes Zertifikat kann den Betrieb unzulässig oder unversichert machen.",
    renewExpiring: "Eine Verlängerung vor Ablauf vermeidet eine Lücke im Schutz.",
    repeatFault_one: "Es brauchte bereits einmal einen Auftrag.",
    repeatFault_other: "Es brauchte bereits {{count}}-mal einen Auftrag.",
    reviewRisk: "Das Risiko ist {{level}}.",
    rework_one: "Ein Auftrag wurde zurückgewiesen.",
    rework_other: "{{count}} Aufträge wurden zurückgewiesen.",
  },
  jobTitle: {
    planReplacement: "Ersatz planen",
    findCause: "Ursache des wiederkehrenden Mangels finden: {{item}}",
    renewCertificates: "Abgelaufene Zertifikate erneuern",
    riskReview: "Risikoprüfung",
  },
  getMore: {
    addValue: "Tragen Sie ein, wann es eingebaut wurde, wie lange es halten soll und was ein Ersatz kostet, damit der Bericht Lebensdauer und Wert zeigt.",
    addValueButton: "Wert und Lebensdauer eintragen",
    addDetails: "Ergänzen Sie fehlende Angaben, um die Datenqualität und die Sicherheit jedes Abschnitts zu erhöhen.",
    addDetailsButton: "Asset bearbeiten",
    addSiteDetails: "Ergänzen Sie fehlende Angaben zum Standort, um die Datenqualität zu erhöhen.",
    addSiteDetailsButton: "Standort bearbeiten",
    groupRule: "Legen Sie eine Gruppenregel an, damit Assets wie dieses automatisch die richtigen Prüfungen erhalten.",
    groupRuleButton: "Gruppenregeln öffnen",
    inviteContractor: "Laden Sie Ihre Dienstleister ein, damit ihre Arbeiten mit Belegen erfasst werden.",
    inviteContractorButton: "Dienstleister einladen",
    linkAssets: "Verknüpfen Sie es mit den Assets, von denen es abhängt oder die es versorgt, damit Folgerisiken sichtbar werden.",
    linkAssetsButton: "Verknüpfungen hinzufügen",
    placeAssets: "Ordnen Sie die Assets des Standorts Gebäuden und Bereichen zu, damit Probleme nach Ort sichtbar werden.",
    placeAssetsButton: "Standort öffnen",
    placeOnSite: "Ordnen Sie es einem Standort zu, damit der Bericht sein Umfeld beschreiben kann.",
    placeOnSiteButton: "Standort wählen",
    scheduleInspection: "Planen Sie eine Inspektion, damit sein Zustand bekannt ist.",
    scheduleInspectionButton: "Inspektion planen",
    siteAddress: "Fügen Sie die Adresse oder Kartenposition des Standorts hinzu.",
    siteAddressButton: "Adresse hinzufügen",
    uploadCertificate: "Laden Sie seine Zertifikate hoch, damit die Compliance belegt werden kann.",
    uploadCertificateButton: "Dokument hochladen",
  },
  coverage: {
    asset: {
      site: "ein Standort",
      place: "wo es sich befindet",
      links: "Verknüpfungen zu anderen Assets",
      documents: "Dokumente",
      inspection: "eine Inspektion in diesem Jahr",
      risk: "eine Risikobewertung",
      criticality: "Kritikalität",
      figures: "nächtliche Zahlen",
      work: "Auftragshistorie",
      schedule: "geplante Prüfungen",
    },
    site: {
      address: "eine Adresse oder Kartenposition",
      summary: "eine nächtliche Zusammenfassung",
      areas: "Gebäude und Bereiche",
      inspected: "Inspektionen für fast jedes Asset",
      assessed: "Risikobewertungen für fast jedes Asset",
      evidence: "Belege für fast jedes Asset",
      contractors: "Arbeiten von Dienstleistern",
      located: "Kartenpositionen der Assets",
    },
  },
  gaps: {
    missingField: "Kein Wert für {{field}} erfasst.",
    neverInspected: "Nie inspiziert, daher ist der aktuelle Zustand unbekannt.",
    inspectedLongAgo: "Zuletzt vor {{days}} Tagen inspiziert, daher kann sich der Zustand verändert haben.",
    noInspectionThisYear: "In den letzten 12 Monaten wurde keine Inspektion abgeschlossen.",
    noDocuments: "Keine Dokumente (Zertifikate, Handbücher, Garantien) hinterlegt.",
    noPhotos: "Keine Fotos.",
    noRiskAssessment: "Es wurde keine Risikobewertung durchgeführt.",
    noSite: "Keinem Standort zugeordnet, daher lässt sich das Umfeld nicht beschreiben.",
    noLocation: "Keine Kartenposition.",
    noLinks: "Mit keinem verwandten Asset verknüpft, daher sind Folgewirkungen unbekannt.",
    retiredWithOpenJobs_one: "Als {{status}} markiert, hat aber noch {{count}} offenen Auftrag.",
    retiredWithOpenJobs_other: "Als {{status}} markiert, hat aber noch {{count}} offene Aufträge.",
    riskWithoutCriticality: "Hat einen Risikowert, aber keine Kritikalität, daher beruht der Wert auf einer Voreinstellung.",
    zonesWithoutSite: "Hat Zonen, aber keinen Standort, daher gehören die Zonen zu nichts.",
    noStoredFigures: "Noch keine gespeicherten Tageszahlen, daher können keine Verläufe gezeigt werden.",
    staleFigures: "Die gespeicherten Tageszahlen sind {{days}} Tage alt.",
    missingFieldOnAssets_one: "Kein Wert für {{field}} bei {{count}} von {{total}} Assets.",
    missingFieldOnAssets_other: "Kein Wert für {{field}} bei {{count}} von {{total}} Assets.",
    noAssets: "Keine Assets an diesem Standort.",
    assetsNotInspected_one: "{{count}} von {{total}} Assets wurde in den letzten 12 Monaten nicht inspiziert.",
    assetsNotInspected_other: "{{count}} von {{total}} Assets wurden in den letzten 12 Monaten nicht inspiziert.",
    noInspectionHistory: "Für diesen Standort ist noch keine Inspektionshistorie zusammengefasst.",
    assetsWithNothing_one: "Zu einem Asset ist gar nichts erfasst.",
    assetsWithNothing_other: "Zu {{count}} Assets ist gar nichts erfasst.",
    assetsNotAssessed_one: "Ein Asset hat keine Risikobewertung.",
    assetsNotAssessed_other: "{{count}} Assets haben keine Risikobewertung.",
    siteNotLocated: "Der Standort hat keine Adresse und keine Kartenposition.",
    assetsNotLocated_one: "{{count}} von {{total}} Assets hat keine Kartenposition.",
    assetsNotLocated_other: "{{count}} von {{total}} Assets haben keine Kartenposition.",
    noSiteSummary: "Noch keine gespeicherte Standortzusammenfassung, daher können keine Verläufe gezeigt werden.",
    staleSiteSummary: "Die gespeicherte Standortzusammenfassung ist {{days}} Tage alt.",
    assetCountMoved_one: "Der Standort hat jetzt {{count}} Asset, aber die Zusammenfassung der letzten Nacht zählte {{summarised}}.",
    assetCountMoved_other: "Der Standort hat jetzt {{count}} Assets, aber die Zusammenfassung der letzten Nacht zählte {{summarised}}.",
    assetsRiskWithoutCriticality_one: "Ein Asset hat einen Risikowert, aber keine Kritikalität.",
    assetsRiskWithoutCriticality_other: "{{count}} Assets haben einen Risikowert, aber keine Kritikalität.",
  },
  versions: {
    title: "Versionen",
    hint: "Jede gespeicherte Version bleibt genau so, wie sie war. Öffnen Sie eine, um sie zu lesen oder mit der vorherigen zu vergleichen.",
    none: "Noch keine gespeicherten Versionen. Speichern Sie diese Version oder lassen Sie die KI-Fassung schreiben, um die Liste zu beginnen.",
    save: "Diese Version speichern",
    saveFailed: "Version konnte nicht gespeichert werden",
    savedTitle: "Gespeichert",
    savedBody: "Als Version {{version}} gespeichert.",
    label: "Version {{version}} · {{date}}",
    ai: "Von der KI geschrieben",
    app: "Die Zahlen der App",
    open: "Öffnen",
    close: "Schließen",
    viewing: "Sie lesen Version {{version}}, gespeichert am {{date}}.",
    backToCurrent: "Zurück zum aktuellen Bericht",
  },
  compare: {
    title: "Was sich von Version {{older}} zu Version {{newer}} geändert hat",
    show: "Mit Version {{version}} vergleichen",
    hide: "Vergleich ausblenden",
    verdict: "Gesamturteil: {{before}} → {{after}} ({{movement}})",
    dataQuality: "Datenqualität: {{before}} → {{after}} ({{movement}})",
    figure: "{{before}} → {{after}} ({{movement}})",
    actionsAdded: "Neue Maßnahmen: {{n}}",
    actionsGone: "Nicht mehr nötige Maßnahmen: {{n}}",
    bullet: "• {{text}}",
    movement: {
      better: "besser",
      worse: "schlechter",
      same: "unverändert",
      new: "neu",
      gone: "nicht mehr angezeigt",
    },
  },
  share: {
    open: "Teilen",
    title: "Diesen Bericht teilen",
    hint: "Die Person wird in der App und per E-Mail benachrichtigt. Der Link öffnet den Bericht in AssetWRX: Deckblatt und Kennzahlen sofort, der Rest nach Anmeldung oder mit einem kostenlosen Konto.",
    toLabel: "Senden an",
    toPlaceholder: "Kontakte suchen oder E-Mail-Adresse eingeben",
    messageLabel: "Nachricht (optional)",
    messagePlaceholder: "Fügen Sie eine Notiz für den Empfänger hinzu...",
    savesFirst: "Was auf dem Bildschirm steht, wird zuerst als neue Version gespeichert, damit genau das gelesen wird.",
    send: "Bericht senden",
    sentTitle: "Geteilt",
    sentBody: "Version {{version}} wurde mit {{who}} geteilt.",
    failedTitle: "Teilen nicht möglich",
    failedBody: "Etwas ist schiefgelaufen. Versuchen Sie es erneut.",
    sharedWith: "Geteilt mit",
    versionOn: "Version {{version}} · {{date}}",
    read: "Gelesen am {{date}}",
    notRead: "Noch nicht gelesen",
    withdrawn: "Zurückgezogen",
    replaced: "Durch eine neuere Version ersetzt",
    sendNew: "Version {{version}} senden",
    withdraw: "Zurückziehen",
    close: "Schließen",
  },
  download: {
    pdf: "PDF herunterladen",
    csv: "CSV herunterladen",
    approverOnly: "Herunterladen dürfen nur die Personen, die Arbeiten an dieser Anlage freigeben. Mit „Teilen“ senden Sie den Bericht an jemanden.",
  },
  csv: {
    similarMiddle: "Mitte der Vergleichbaren",
    basis: "Grundlage",
    part: "Teil",
    item: "Eintrag",
    value: "Wert",
    band: "Bewertung",
    note: "Hinweis",
    subject: "Gegenstand",
    version: "Version",
    written: "Erstellt",
    reader: "Geschrieben für",
  },
  shared: {
    header: "Geteilter Bericht",
    loadFailed: "Der Bericht konnte nicht geladen werden.",
    notFound: "Dieser Link führt zu keinem Bericht.",
    goToApp: "Zu AssetWRX",
    revoked: "Dieser Bericht wird nicht mehr mit Ihnen geteilt.",
    replaced: "Eine neuere Version dieses Berichts wurde mit Ihnen geteilt.",
    openNewer: "Neuere Version öffnen",
    notYours: "Dieser Bericht wurde mit jemand anderem geteilt. Melden Sie sich mit der Adresse an, an die er gesendet wurde.",
    verdict: "Gesamturteil: {{rating}}",
    gateTitle: "Den ganzen Bericht lesen",
    gateBody: "Melden Sie sich an oder legen Sie ein kostenloses Konto an, um alle Abschnitte, den Maßnahmenplan und die Datenqualität zu lesen.",
    signIn: "Anmelden",
    createAccount: "Kostenloses Konto anlegen",
    sharedBy: "Geteilt von {{who}} am {{date}}",
    sharedOn: "Geteilt am {{date}}",
    note: "Nachricht: {{message}}",
    newerExists: "Es gibt eine neuere Version (Version {{version}}). Fragen Sie die absendende Person, wenn Sie sie brauchen.",
    readOnly: "Nur lesen. Dieser Bericht bleibt so, wie er beim Teilen war.",
  },
  comparison: {
    title: "Im Vergleich",
    measure: {
      compliance: "Compliance",
      condition: "Zustand",
      risk: "Risiko",
      right_first_time: "Beim ersten Mal richtig",
    },
    position: {
      better: "besser als die meisten",
      similar: "etwa wie die meisten",
      worse: "hinter den meisten",
    },
    row: "{{value}}, {{position}} (Mitte der Vergleichbaren: {{middle}})",
    notEnough: "Zu wenige Vergleichbare haben diesen Wert.",
    basis: {
      asset_one: "Verglichen mit 1 ähnlichen Anlage, die Sie sehen können, nach den Werten der letzten Nacht.",
      asset_other: "Verglichen mit {{count}} ähnlichen Anlagen, die Sie sehen können, nach den Werten der letzten Nacht.",
      site_one: "Verglichen mit 1 anderen Standort, den Sie sehen können, nach den Werten der letzten Nacht.",
      site_other: "Verglichen mit {{count}} anderen Standorten, die Sie sehen können, nach den Werten der letzten Nacht.",
    },
    finding: {
      behind: "Bei {{measure}} hinter den meisten Vergleichbaren.",
      ahead: "Bei {{measure}} vor den meisten Vergleichbaren.",
      inLine: "Im Rahmen der Vergleichbaren.",
    },
  },
  value: {
    title: "Wert und Lebensdauer",
    measure: {
      installed_on: "Eingebaut",
      age: "Alter",
      expected_life: "Erwartete Lebensdauer",
      remaining_life: "Restlebensdauer",
      purchase_cost: "Anschaffungskosten",
      replacement_cost: "Ersatzkosten",
      spend: "Ausgaben für Aufträge",
      spend_share: "Ausgaben im Verhältnis zu den Ersatzkosten",
      replacement_total: "Erfasster Ersatzwert",
      assets_with_value: "Anlagen mit Ersatzkosten",
      past_life: "Anlagen über der erwarteten Lebensdauer",
    },
    years_one: "{{value}} Jahr",
    years_other: "{{value}} Jahre",
    lifeUsed: "{{pct}} % der erwarteten Lebensdauer verbraucht",
    finding: {
      pastLife: "Die erwartete Lebensdauer ist um {{years}} Jahre überschritten.",
      spendHigh: "Ein Jahr Aufträge kostete {{pct}} % eines Ersatzes. Ersetzen kann günstiger sein als Reparieren.",
      nearEnd: "{{pct}} % der erwarteten Lebensdauer sind verbraucht.",
      lifeLeft: "Etwa {{years}} Jahre der erwarteten Lebensdauer bleiben.",
      recorded: "Was zum Wert erfasst ist.",
      sitePastLife_one: "1 von {{of}} Anlagen mit erfasster Lebensdauer ist darüber.",
      sitePastLife_other: "{{count}} von {{of}} Anlagen mit erfasster Lebensdauer sind darüber.",
      siteRecorded_one: "Für 1 von {{of}} Anlagen sind Ersatzkosten erfasst.",
      siteRecorded_other: "Für {{count}} von {{of}} Anlagen sind Ersatzkosten erfasst.",
      siteSpendOnly: "Was die Aufträge des Standorts gekostet haben.",
    },
    spendBasis: {
      year: "Ausgaben der letzten 12 Monate, aus {{withCost}} von {{jobs}} abgeschlossenen Aufträgen mit Kosten.",
      ninetyDays: "Ausgaben der letzten 90 Tage, aus {{withCost}} von {{jobs}} abgeschlossenen Aufträgen mit Kosten.",
    },
    marketTitle: "Üblicher Marktpreis",
    marketHint: "Aus Online-Quellen, nicht von AssetWRX geprüft.",
  },
esg: {
section: "Energie, CO₂ und Nachhaltigkeit (ESG)",
basis: "Aus Zählerständen der letzten 24 Monate, erfassten Kältemitteln und Energieausweisen sowie CO₂-Faktoren der britischen Regierung ({{year}}). CO₂ ist eine Schätzung.",
ratingsTable: "Energieausweise",
col: {
certificate: "Ausweis",
rating: "Klasse",
},
finding: {
belowMinimum: "Energieausweise unter dem Vermietungsminimum (E): {{n}}.",
fgasOverdue: "Überfällige F-Gas-Dichtheitsprüfungen: {{n}}.",
noMeters: "Es sind keine Energiezähler erfasst, daher können Energie und CO₂ nicht gemessen werden.",
energyChange: "{{kwh}} kWh in den letzten 12 Monaten ({{change}} % gegenüber Vorjahr), etwa {{tonnes}} t CO₂e.",
energy: "{{kwh}} kWh in den letzten 12 Monaten, etwa {{tonnes}} t CO₂e.",
},
meaning: {
belowMinimum: "Ein Gebäude in England und Wales darf unter E ohne Ausnahme nicht vermietet werden. Planen Sie die Verbesserung oder registrieren Sie eine Ausnahme.",
fgasOverdue: "Überfällige Dichtheitsprüfungen verstoßen gegen die F-Gas-Regeln und lassen Kältemittel, ein starkes Treibhausgas, unbemerkt entweichen.",
noMeters: "Ohne Zähler sind Energieverbrauch und CO₂ unbekannt. Fügen Sie Zähler hinzu und erfassen Sie Ablesungen.",
noFloorArea: "Ergänzen Sie die Nutzfläche, um den Verbrauch pro m² mit anderen Gebäuden zu vergleichen.",
ok: "Energie und CO₂ werden gemessen. Lesen Sie regelmäßig ab, damit die Zahlen vollständig bleiben.",
},
stat: {
energy: "Energie, kWh (12 Monate)",
change: "Änderung zum Vorjahr, %",
intensity: "kWh pro m²",
carbon: "CO₂, t CO₂e",
scope1: "Scope 1, t CO₂-Äq.",
scope2: "Scope 2, t CO₂-Äq.",
water: "Wasser, m³",
meters: "Zähler mit Ablesung",
refrigerant: "Kältemittel, t CO₂e",
fgasOverdue: "Überfällige F-Gas-Prüfungen",
},
status: {
belowMinimum: "Unter dem Vermietungsminimum",
expired: "Abgelaufen",
expiresSoon: "Läuft in 6 Monaten ab",
valid: "Gültig",
},
action: {
improveEpc: "Maßnahmen planen, um die Energieklasse auf E oder besser zu heben",
fgasOverdue: "Überfällige F-Gas-Dichtheitsprüfungen durchführen ({{n}})",
renewEpc: "Abgelaufenen Energieausweis erneuern",
readMeters: "Zähler ohne Ablesung seit 3 Monaten ablesen ({{n}})",
},
why: {
improveEpc: "Unter E darf es ohne Ausnahme nicht vermietet werden.",
fgasOverdue: "Dichtheitsprüfungen sind bei dieser Kältemittelmenge Pflicht.",
renewEpc: "Für Verkauf oder Vermietung ist ein Energieausweis nötig.",
readMeters: "Lücken bei den Ablesungen machen Energie- und CO₂-Zahlen unvollständig.",
},
jobTitle: {
improveEpc: "Maßnahmen zur Verbesserung der Energieklasse",
renewEpc: "Energieausweis erneuern",
},
},
};
